import { ReactRenderer } from '@tiptap/react';
import tippy, { Instance as TippyInstance } from 'tippy.js';
import { SuggestionOptions } from '@tiptap/suggestion';
import MentionList from './MentionList';

interface ConnectedNode {
  id: string;
  label: string;
}

export default function suggestion(
  getConnectedNodes: () => ConnectedNode[],
): Omit<SuggestionOptions, 'editor'> {
  return {
    items: ({ query }: { query: string }) => {
      const connectedNodes = getConnectedNodes();
      return connectedNodes
        .filter((node) =>
          node.label.toLowerCase().includes(query.toLowerCase()),
        )
        .slice(0, 5);
    },

    render: () => {
      let component: ReactRenderer;
      let popup: TippyInstance[];

      return {
        onStart: (props) => {
          component = new ReactRenderer(MentionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect as () => DOMRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start',
          });
        },

        onUpdate(props) {
          component.updateProps(props);

          if (!props.clientRect) {
            return;
          }

          popup[0].setProps({
            getReferenceClientRect: props.clientRect as () => DOMRect,
          });
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            popup[0].hide();

            return true;
          }

          return (component.ref as any)?.onKeyDown(props);
        },

        onExit() {
          popup[0].destroy();
          component.destroy();
        },
      };
    },
  };
}
